import React from 'react';
import { useTranslation } from 'react-i18next';
import countries from 'i18n-iso-countries';

const Country = ({ language, value, onChange, error }) => {
    const { t, i18n } = useTranslation();
  
    // Registra los locales necesarios
    countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
    countries.registerLocale(require('i18n-iso-countries/langs/es.json'));
  
    // Obtiene el código del idioma actual
    let countryCode = language || i18n.languages[0].split('-')[0];

    // Obtiene los nombres de los países en el idioma actual y los ordena alfabéticamente
    const countryNames = Object.entries(countries.getNames(countryCode.toUpperCase()))
                              .sort((a, b) => a[1].localeCompare(b[1]));

    const handleCountryChange = (e) => {
      const selectedValue = e.target.value;
      onChange(selectedValue);
    };
  
    return (
      <label>
        <select className='textField-select'
          name="country"
          value={value}
          onChange={handleCountryChange}
        >
          <option value="">{t('form.select')}</option>
          {countryNames.map(([code, name]) => (
            <option key={code} value={name}>
              {name}
            </option>
          ))}
        </select>
        {error && <span className="errorMessage">{error}</span>}
      </label>
    );
  };
  
export default Country;
